import {CardNoteModel} from '../../models/api/cardNoteModel';

/** Gets the date for the note to display */
export function getCardNoteDisplayDate(note: CardNoteModel) {
  // TODO: Enable when we keep track of the edited user.
  // return note.createdAt > note.updatedAt ? note.createdAt : note.updatedAt;
  return note.createdAt;
}

/*
 * Type enum.
 */

export enum CardNoteUpdateActionsEnum {
  CREATE_NOTE = 'CREATE_NOTE',
  UPDATE_NOTE = 'UPDATE_NOTE',
  DELETE_NOTE = 'DELETE_NOTE',
}

/*
 * Action Types.
 */

interface CreateNoteAction {
  type: CardNoteUpdateActionsEnum.CREATE_NOTE;
  payload: {
    note: CardNoteModel;
  };
}
interface UpdateNoteAction {
  type: CardNoteUpdateActionsEnum.UPDATE_NOTE;
  payload: {
    currentNote: CardNoteModel;
    newNote: CardNoteModel;
  };
}

interface DeleteNoteAction {
  type: CardNoteUpdateActionsEnum.DELETE_NOTE;
  payload: {
    note: CardNoteModel;
  };
}

/*
 * Action creators.
 */

export function createNote(note: CardNoteModel): CreateNoteAction {
  return {
    type: CardNoteUpdateActionsEnum.CREATE_NOTE,
    payload: {
      note,
    },
  };
}

export function updateNote(currentNote: CardNoteModel, newNote: CardNoteModel): UpdateNoteAction {
  return {
    type: CardNoteUpdateActionsEnum.UPDATE_NOTE,
    payload: {
      currentNote,
      newNote,
    },
  };
}

export function deleteNote(note: CardNoteModel): DeleteNoteAction {
  return {
    type: CardNoteUpdateActionsEnum.DELETE_NOTE,
    payload: {
      note,
    },
  };
}

/*
 * Action Union Type.
 */

export type CardNoteUpdateAction = CreateNoteAction | UpdateNoteAction | DeleteNoteAction;
